// src/components/user/about/map/MapSection.jsx

import React from 'react';
import '../../../../assets/css/user/contact/googlemap/GoogleMap.css';

const MapSection = () => {
  return (
    <section className="map-section">

      {/* Section Heading */}
      <div className="map-heading-wrapper">
        <h2 className="map-heading">Find Us on the Map</h2>
        <p className="map-subheading">
          Serving farmers across Punjab — visit us or book equipment online
        </p>
      </div>

      {/* Full Width Map */}
      <div className="map-wrapper">
        <iframe
          title="FarmTech Location - Gujranwala, Punjab"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d108940.08432956257!2d74.12393!3d32.1877!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391ef6a49e6a7fb7%3A0x7f88b37d3b4de807!2sGujranwala%2C%20Punjab%2C%20Pakistan!5e0!3m2!1sen!2s!4v1700000000000!5m2!1sen!2s"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>

    </section>
  );
};

export default MapSection;